import segment from 'src/js/modules/analytics/segment';

const {
  trackers: { trackEvent },
  constants,
} = segment;

const trackImageResizingCompleted = ({
  blockId,
  blockVariationId,
  oldHeight,
  newHeight,
  affectedImages,
  shiftKeyPressed,
  compositeGroup,
  elementId,
  breakpointType,
}) => {
  trackEvent(constants.events.IMAGE_RESIZING_COMPLETED, {
    elementId,
    blockId,
    blockVariationId,
    oldHeight,
    newHeight,
    affectedImages,
    shiftKeyPressed,
    compositeGroup,
    ...(breakpointType && { breakpointType }),
  });
};

export default trackImageResizingCompleted;
